import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { usePermission } from '../hooks/usePermission';

export default function ProtectedRoute({ children, permission }) {
  const { isAuthenticated } = useContext(AuthContext);
  const { can } = usePermission();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (permission && !can(permission)) return <Navigate to="/403" replace />;
  return children;
}
